import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import { styled, useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import Navigation from "./nav";
import { useQuery } from "@tanstack/react-query";
import { apiCheckAccountStatus } from "../../api/account";
import { useDispatch } from "react-redux";
import {
  setAccount_profile_data,
  setBadge_number,
  setOnboarded,
  setVerification_status,
  setVerified,
} from "../../store/contentSlice";
import { LoadingProgress, LoadingProvider } from "../../hooks/useLoading";

// ----------------------------------------------------------------------

const Main = styled("div")(({ theme }) => ({
  position: "relative",
  marginTop: 80,
  [theme.breakpoints.up("lg")]: {},
}));

export default function DashboardLayout() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);

  //  always return a value to avoid errors
  const query = useQuery({
    queryKey: ["accountStatus"],
    queryFn: async () => {
      const result = await apiCheckAccountStatus();
      if (result?.status === 200) {
        
        if (result?.data?.id_uploaded === 0) {
          dispatch(setVerification_status("not-complete"));
        } else if (result?.data?.id_uploaded === 1) {
          dispatch(setVerification_status("complete"));
        }
        if (result?.data?.kyced === 0) {
          handleVerified(false, 0, result?.data);
          return {};
        } else if (result?.data?.kyced === 1) {
          handleVerified(true, result?.data?.id, result?.data);
          return {};
        }
      }
      return result?.data || {};
    },
  });

  const handleVerified = (
    value: boolean,
    id: number,
    data: {
      account_type: number;
      badge: number;
      email_verified: number;
      id: number;
      id_uploaded: number;
      kyced: number;
      name: string;
      photo_url: string;
    }
  ) => {
    dispatch(setVerified(value));
    dispatch(setOnboarded(value));
    dispatch(setBadge_number(data?.badge));
    dispatch(
      setAccount_profile_data({
        id: id,
        name: data?.name,
        image: data?.photo_url,
        kyced: data?.kyced,
        id_uploaded: data?.id_uploaded,
      })
    );
  };

  return (
    <Box
      sx={{
        height: "100vh",
        background: theme.palette.background.paper,
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          zIndex: 20,
        }}
      >
        <Navigation />
      </Box>
      <Box
        sx={{
          overflowY: "auto",
          height: "100vh",
          width: "100%",
          background: theme.palette.background.paper,
        }}
      >
        <Main>
          <LoadingProvider>
            <LoadingProgress />
            <Outlet />
          </LoadingProvider>
        </Main>
      </Box>
    </Box>
  );
}
